module.exports = __webpack_public_path__ + "img/caja.4df9e24b.svg";